import type { Position } from './types'

/** Rayon terrestre moyen en mètres : le MÊME que `gps_distance_m` (0052), pour que SQL et TypeScript donnent les mêmes distances. */
export const RAYON_TERRE_M = 6371008.8
const rad = (d: number) => (d * Math.PI) / 180

/** Distance de grand cercle (haversine), en mètres — jumelle de `public.gps_distance_m`. */
export function distanceM(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const a = Math.sin(rad(lat2 - lat1) / 2) ** 2 + Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(rad(lng2 - lng1) / 2) ** 2
  return 2 * RAYON_TERRE_M * Math.asin(Math.min(1, Math.sqrt(a)))
}

/** Cap initial de A vers B, en degrés [0, 360). */
export function capEntre(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const y = Math.sin(rad(lng2 - lng1)) * Math.cos(rad(lat2))
  const x = Math.cos(rad(lat1)) * Math.sin(rad(lat2)) - Math.sin(rad(lat1)) * Math.cos(rad(lat2)) * Math.cos(rad(lng2 - lng1))
  return (((Math.atan2(y, x) * 180) / Math.PI) % 360 + 360) % 360
}

/** Position plausible : dans le globe, et pas le (0, 0) par défaut d'un appareil. */
export function coordonneesValides(lat: number, lng: number): boolean {
  return Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180 && !(lat === 0 && lng === 0)
}

/** Longueur d'une ligne brisée, en mètres. */
export function longueurM(points: readonly Pick<Position, 'lat' | 'lng'>[]): number {
  let s = 0
  for (let i = 1; i < points.length; i++) s += distanceM(points[i - 1]!.lat, points[i - 1]!.lng, points[i]!.lat, points[i]!.lng)
  return s
}

/** Écart angulaire le plus court entre deux caps (0..180). */
export function ecartAngle(a: number, b: number): number {
  const d = Math.abs(a - b) % 360
  return d > 180 ? 360 - d : d
}

/** Cap interpolé le long du plus court chemin angulaire. */
export function melangerCap(a: number, b: number, u: number): number {
  let d = ((b - a + 540) % 360) - 180
  if (d > 180) d -= 360
  return (((a + d * u) % 360) + 360) % 360
}
